/*
  alpha filter
*/
/**
 * Desktop/Mobile ALPHA FILTER script
 */

  /************************************************



         ALPHA FILTER FIRST INIT



  *************************************************/
  var desk_alpha_filter_switchs = "[class^=desk_alpha_filter-] .title_content_wrapper_2 > .display > div";
  var desk_item_list = $("[class^=desk_merchant_block_list_w_filter-][data-paging]");
  var mob_item_list = $("[class^=mob_merchant_block_list-]");
  var alpha_filter_module = $("[class^=desk_alpha_filter-]");
  var mobile_alpha_filter_module = $(".filter-bar-mobile");
  var desk_modules_using_paging = $("[class^=desk][data-type=module][data-paging]");
  var mob_modules_using_paging = $("[class^=mob][data-type=module][data-paging]");
  var desk_alpha_filter_select = "[class^=desk_alpha_filter-] .sort-by-list .trigger";// SELECT LIST MANAGEMENT


  //== first init
  $(desk_alpha_filter_switchs).each(function() {
    if ($(this).hasClass("selected")) {
      if ($(this).hasClass("display_line")) {
        desk_item_list.find(".blocks").hide();
        desk_item_list.find(".lines").show();
      }
      else {
        desk_item_list.find(".lines").hide();
        desk_item_list.find(".blocks").show();
      }
    }
  });


  var PAGING_CURRENT_PAGE = 0;
  var PAGING_NB_PAGES = 0;
  var PAGING_NB_ITEMS = 0;
  var NB_PER_PAGE = 6;
  var FILTER_CURRENT = "all";


  /**
   * PAGING PLUGIN
   * + MOBILE ALPHA FILTER MANAGEMENT
   * use paging.setup() to initiate it
   * @param {INT} nbPerPage - nb of items per page
   * @type {Object}
   */
  var paging = {
    els: {
      module: '',
      mobile_module: '',
      filter_module: false,
      mobile_filter_module: '',
      lists: '',
      mobile_list: '',
      nbPerPage: 0,
    },
    setup: function(nbPerPage) {

      //== save module element
      paging.els.module = desk_modules_using_paging;
      paging.els.mobile_module = mob_modules_using_paging;

      //== save nb per page (desktop only)
      paging.els.nbPerPage = nbPerPage;

      //== module's lists of items
      var lists = paging.getLists(desk_modules_using_paging);
      var mobile_list = paging.getLists(mob_modules_using_paging);

      //== save lists elements
      paging.els.lists = lists;
      paging.els.mobile_list =  mobile_list;

      //== set & get nb items (get only the desktop nb, it's the same as on mobile)
      paging.setNbItems(lists);
      var nb_items = paging.getNbItems();

      //== calculate & set nb pages
      var nb_page = Math.ceil(nb_items / nbPerPage);
      paging.setNbPages(nb_page);

      //== set default page (desktop only)
      paging.setPage(1, true);

      //== create holder (desktop only)
      paging.createHolder(lists);

      //=== if an alpha filter exists for both mobile & desktop...
      if (alpha_filter_module.length && mobile_alpha_filter_module.length) {
        paging.els.filter_module = alpha_filter_module;
        paging.els.mobile_filter_module = mobile_alpha_filter_module;
        paging.prepareAlphaFilter();
      }
    },
    getLists: function(module) {
      //== if it exists...
      if (module.length) {

        //== if the module as the correct attr...
        if (module.is("[data-paging]")) {

          //== get the list class name of the module (to get the items inside)
          var list_name = module.attr("data-paging");
          var lists = module.find("."+list_name);

          //== if the lists exists...
          if (lists.length) {
            return lists;
          }
        }
      }
    },
    getItems: function(list, all) {
      if (typeof list == "undefined") return;
      return all ? list.children() : list.children(":not(.hidden)");
    },
    getFirstLetterOfItem: function(item) {
      var name_els = item.find("[data-search-name]");
      var nb_name_els = name_els.length;

      if (nb_name_els) {
        //== get the first one
        name_el = name_els.eq(0);
        name_text = $.trim(name_el.text());

        //== get "first_letter"
        return name_text.charAt(0).toLowerCase();
      }
    },
    setNbItems: function(list) {
      if (typeof list == "undefined") {
        PAGING_NB_ITEMS = 0;
        return;
      }
      if (list.length > 1) {
        list = list.eq(0);
      }
      PAGING_NB_ITEMS = paging.getItems(list, false).length;
    },
    setNbPages: function(nb) {
      PAGING_NB_PAGES = nb;
    },
    getNbItems: function() {
      return PAGING_NB_ITEMS;
    },
    getNbPages: function() {
      return PAGING_NB_PAGES;
    },
    getPage: function() {
      return PAGING_CURRENT_PAGE;
    },
    setPage: function(nb, force) {
      if (PAGING_CURRENT_PAGE != nb || force) {
        PAGING_CURRENT_PAGE = nb;
        paging.update();
      }
    },
    pageUp: function() {
      if (PAGING_CURRENT_PAGE < PAGING_NB_PAGES) {
        paging.setPage(((PAGING_CURRENT_PAGE * 1) + 1), false);
      }
    },
    pageDown: function() {
      if (PAGING_CURRENT_PAGE > 1) {
        paging.setPage(((PAGING_CURRENT_PAGE * 1) - 1), false);
      }
    },
    update: function() {
      var lists = paging.els.lists;
      var items_extract = "";

      if (typeof lists == "undefined") return;

      //== hide/show items according to the getItems method and the current page number
      lists.each(function() {
        var list = $(this);

        var items = paging.getItems(list, false);
        items_extract = items;

        items.css({visibility: "hidden", height: "0", position: "absolute", opacity: "0"});

        for (var i = 0; i < paging.els.nbPerPage; i++) {
          var index = (paging.els.nbPerPage * (PAGING_CURRENT_PAGE - 1)) + i;
          items.eq(index).css({visibility: "visible", height: "auto", position: "relative"}).animate({opacity: "1"}, 400);
        }
      });

      paging.checkNavStatus();
      paging.showItemCount(items_extract);
    },
    createHolder: function(lists) {

      if (typeof lists == "undefined") return;

      lists.each(function() {
        var l = $(this);
        var holder_el = l.nextAll(".jp-holder").show();
        var arrow_prev_el = l.nextAll(".jp-nav-previous").show();
        var arrow_next_el = l.nextAll(".jp-nav-next").show();

        //== clean existing links
        holder_el.find("a, span").remove();

        //-- link list
        var link_list = "";

        for (var i = 1; i <= PAGING_NB_PAGES; i++) {
          link_list = link_list + paging.createHolderLink(i);
        }

        holder_el.append(link_list);

        paging.listenToHolder(holder_el);
        paging.checkNavStatus();
      });

      //== event handler for arrows
      paging.listenToArrow();
    },
    createHolderLink: function(nb) {
      var hidden = '';
      var dots = '';

      //-- created dotted spans
      if (nb === 1) {
        dots = '<span class="hidden sep_dots" data-pos="begin">...</span>';
      }
      else if (nb === (PAGING_NB_PAGES - 1) && nb > 6) {
        dots = '<span class="sep_dots" data-pos="end">...</span>';
      }

      //-- hide unwanted page numbers
      if (nb > 5 && nb < PAGING_NB_PAGES && PAGING_NB_PAGES > 6) {
        hidden = 'hidden';
      }

      var link = '<a href="#" class="'+hidden+'">'+nb+'</a>' + dots;

      return link;
    },
    showItemCount: function(items) {
      var item_count_el = alpha_filter_module.find(".nb_item_count");
      var item_count_text = item_count_el.text();
      var item_count_text_clean = item_count_text.match(/[a-zA-Z]+/g);
      item_count_el.text(items.length+" "+item_count_text_clean);
    },
    checkNavStatus: function() {
      //== get lists
      var lists = paging.els.lists;

      //== go through each lists
      lists.each(function() {
        var l = $(this);
        var holder_el = l.nextAll(".jp-holder");
        var holder_el_links = holder_el.find("a");

        //== add selected status to the right paging link
        holder_el_links.each(function() {
          var link = $(this);
          var page_nb = link.text() * 1;

          if (page_nb == PAGING_CURRENT_PAGE) {
            holder_el_links.removeClass("jp-current");
            link.addClass("jp-current");
          }
        });

        //-- update links
        paging.updateHolderLinks(holder_el_links);

        //== display / hide arrows
        var prev_custom = l.nextAll(".jp-nav-previous");
        var next_custom = l.nextAll(".jp-nav-next");

        if (PAGING_CURRENT_PAGE == PAGING_NB_PAGES) {
          next_custom.addClass("disabled");

          if (PAGING_CURRENT_PAGE == 1) {
            prev_custom.addClass("disabled");
          }
          else {
            prev_custom.removeClass("disabled");
          }
        }
        else if (PAGING_CURRENT_PAGE > 1 && PAGING_CURRENT_PAGE < PAGING_NB_PAGES) {
          prev_custom.removeClass("disabled");
          next_custom.removeClass("disabled");
        }
        else if (PAGING_CURRENT_PAGE <= 1) {
          prev_custom.addClass("disabled");
          next_custom.removeClass("disabled");
        }
      });
    },
    listenToHolder: function(el) {
      var holder_links = el.find("a");

      //== remove existing event handler
      holder_links.off(".paging");

      //== on holder link click (pagination click)
      holder_links.on("click.paging", function(e) {
        //-- init
        e.preventDefault();
        var nb = $(this).text();

        //== set new page
        paging.setPage(nb, false);
      });
    },
    updateHolderLinks: function(links) {
      //-- init
      var max_pages_at_once = 6;
      var pages_interval = 5;
      var delta_nbpages_currentpage = PAGING_NB_PAGES - PAGING_CURRENT_PAGE;
      var loop_nb, start_index, end_index;

      //-- start use of the dots if number of pages > max_pages_at_once
      if (PAGING_NB_PAGES > max_pages_at_once) {

        //-- hide all except first and last
        links.addClass("hidden");
        links.first().removeClass("hidden");
        links.last().removeClass("hidden");

        //-- show the firsts links
        if (PAGING_CURRENT_PAGE < pages_interval) {

          //-- choose between 5 or 6 first elements to show
          loop_nb = PAGING_CURRENT_PAGE < 4 ? pages_interval : max_pages_at_once;

          //-- unhide firsts
          for (var i = 1; i <= loop_nb; i++) {
            links.eq(i - 1).removeClass("hidden");
          }
        }
        //-- show the last links
        else if (delta_nbpages_currentpage < (pages_interval - 1)) {

          //-- choose between 5 or 6 first elements to show
          loop_nb = delta_nbpages_currentpage < 3 ? pages_interval : max_pages_at_once;

          //-- choose start and end index for Looping
          start_index = PAGING_NB_PAGES - (loop_nb - 1);
          end_index = PAGING_NB_PAGES;

          //-- unhide firsts
          for (var j = start_index; j <= end_index; j++) {
            links.eq(j - 1).removeClass("hidden");
          }
        }
        else {
          loop_nb = pages_interval;

          //-- choose start and end index for Looping
          start_index = PAGING_CURRENT_PAGE - 2;
          end_index = start_index + loop_nb;

          //-- unhide +2 and -2 around the current page
          for (var k = start_index; k < end_index; k++) {
            links.eq(k - 1).removeClass("hidden");
          }
        }

        //-- show dots
        if (PAGING_CURRENT_PAGE >= pages_interval && delta_nbpages_currentpage <= 3) {
          paging.showBeginDots();
        }
        else if (delta_nbpages_currentpage > 3 && PAGING_CURRENT_PAGE < pages_interval) {
          paging.showEndDots();
        }
        else {
          paging.showBothDots();
        }
      }
    },
    showEndDots: function() {
      $(".sep_dots[data-pos=begin]").addClass("hidden");
      $(".sep_dots[data-pos=end]").removeClass("hidden");
    },
    showBeginDots: function() {
      $(".sep_dots[data-pos=end]").addClass("hidden");
      $(".sep_dots[data-pos=begin]").removeClass("hidden");
    },
    showBothDots: function() {
      $(".sep_dots[data-pos=end]").removeClass("hidden");
      $(".sep_dots[data-pos=begin]").removeClass("hidden");
    },
    listenToArrow: function() {
      var module = paging.els.module;
      //== get arrows element
      var arrow_prev_class = ".jp-nav-previous .circle";
      var arrow_next_class = ".jp-nav-next .circle";

      //== remove existing event handler
      $(module).off(".paging");

      //= previous page
      $(module).on("click.paging", arrow_prev_class, function() {
        paging.pageDown();
      });

      //= next page
      $(module).on("click.paging", arrow_next_class, function() {
        paging.pageUp();
      });
    },
    stop: function() {

      var lists = paging.els.lists;

      lists.each(function() {
        var list = $(this);

        //== get list's items
        var items = paging.getItems(list, false);

        //== show them all
        items.css({visibility: "visible", height: "auto", position: "relative"}).animate({opacity: "1"}, 400);

        //== hide paging holders and arrows
        var holder_el = list.nextAll(".jp-holder").hide();
        var arrow_prev_el = list.nextAll(".jp-nav-previous").hide();
        var arrow_next_el = list.nextAll(".jp-nav-next").hide();
      });
    },
    reboot: function() {
      paging.setup(paging.els.nbPerPage);
    },
    prepareAlphaFilter: function() {
      //== init
      var filter = paging.els.filter_module;
      var mobile_filter = paging.els.mobile_filter_module;
      var items_first_letter = [];

      //== get all letters of the filter bar (desktop & mobile)
      var filter_alpha_bar_letters = filter.find(".alpha_bar .list a");
      var mobile_filter_alpha_letters = mobile_filter.find(".items .item");

      //== get lists of the items contained inside linked module of the current filter module
      var lists = paging.els.lists;

      //== if lists exists...
      if (lists.length) {

        //== get the first list
        var list = lists.eq(0);

        //== get list items
        var items = paging.getItems(list, true);

        //== set the count
        // setItemCount(filter, items);

        //=== get item first letter and store it
        items.each(function() {
          var item = $(this);
          var first_letter = paging.getFirstLetterOfItem(item);
          items_first_letter.push(first_letter);
        });

        //== use stored item first letters to configure the alpha filter bar
        var letters_done = ["all"];
        var nb_items_first_letter = items_first_letter.length;

        for (var i = 0; i < nb_items_first_letter; i++) {

          //== init
          var letter = items_first_letter[i];

          //== test if letter is a simple char or a special char
          //== if so, assign "123" to its value so its considered as a special letter
          if (!isSimpleChar(letter)) {
            letter = "123";
          }

          //== if this letter has not been processed already
          if (!in_array(letter, letters_done)) {

            //== go through the alpha bar desktop
            filter_alpha_bar_letters.each(function() {

              //== init
              var _this = $(this);
              var _this_hasSpecialCharClass = false;
              var _this_letter = $.trim(_this.text().toLowerCase());

              //== check for special class chars
              if (_this.hasClass("123")) {
                _this_hasSpecialCharClass = true;
              }

              //== if item letter == alpha bar letter... remove inactive status
              if (_this_letter == letter || (_this_hasSpecialCharClass && letter == "123")) {
                _this.removeClass("inactive");
              }
            });

            //== go through the alpha bar mobile
            mobile_filter_alpha_letters.each(function() {

              //== init
              var _this = $(this);
              var _this_hasSpecialCharClass = false;
              var _this_letter = $.trim(_this.text().toLowerCase());

              //== check for special class chars
              if (_this.hasClass("123")) {
                _this_hasSpecialCharClass = true;
              }

              //== if item letter == alpha bar letter... remove inactive status
              if (_this_letter == letter || (_this_hasSpecialCharClass && letter == "123")) {
                _this.removeClass("inactive");
              }
            });

            //== store the processed letter
            letters_done.push(letter);
          }
        }
      }

      paging.listenToAlphaFilter();
    },
    listenToAlphaFilter: function() {

      //== init
      var filter = paging.els.filter_module;
      var mobile_filter = paging.els.mobile_filter_module;
      var lists = paging.els.lists;
      var items = paging.getItems(lists);
      var mobile_list = paging.els.mobile_module.find("."+paging.els.mobile_module.attr("data-paging"));
      var mobile_items = paging.getItems(mobile_list);

      //== get all letters link of the filter bar (mobile & desktop)
      var filter_alpha_bar_letters = filter.find(".alpha_bar .list a");
      var mobile_filter_alpha_letters = mobile_filter.find(".items .item");
      //== get Sort By list items
      var desktop_sort_by_items = filter.find(".filter-search-list .item a");

      //== remove previous listeners
      filter_alpha_bar_letters.off(".paging");
      mobile_filter_alpha_letters.off(".paging");
      desktop_sort_by_items.off(".paging");

      //====== on letter click on the desktop alpha filter bar...
      filter_alpha_bar_letters.on("click.paging", function(e) {
        //== init
        e.preventDefault();
        var _this = $(this);

        //== if not an inactive link
        if (!_this.hasClass("inactive")) {

          //== clear selected states
          filter_alpha_bar_letters.removeClass("selected");

          //== set selected state
          _this.addClass('selected');

          //== get clicked link value
          var selected_letter = _this.text().toLowerCase();

          //== go through the lists to filter them...
          lists.each(function() {
            var list = $(this);
            var items = paging.getItems(list, true);

            //== show all available items
            if (selected_letter == "all" || _this.hasClass("all")) {
              items.removeClass("hidden");
            }
            //== show items corresponding to the clicked letter
            else {
              items.each(function() {
                var item = $(this);
                var first_letter = paging.getFirstLetterOfItem(item);

                //== specify it's a special char if not an alpha char
                if (!isSimpleChar(first_letter)) {
                  first_letter = "123";
                }

                if (first_letter != selected_letter) {
                  item.addClass("hidden");
                }
                else {
                  item.removeClass("hidden");
                }
              });
            }
          });

          //== reboot paging after filtering
          paging.reboot();
        }
      });

      //====== on letter click on the mobile alpha filter bar...
      mobile_filter_alpha_letters.on("click.paging", function(e) {
        //== init
        e.preventDefault();
        var _this = $(this);

        //== if not an inactive link
        if (!_this.hasClass("inactive")) {
          //== clear selected states
          mobile_filter_alpha_letters.removeClass("selected");

          //== set selected state
          _this.addClass('selected');

          //== get clicked link value
          var selected_letter = $.trim(_this.text().toLowerCase());

          //== get list items
          var items = paging.getItems(mobile_list, true);

          //== show all available items
          if (selected_letter == "all") {
            items.removeClass("hidden");
          }
          //== show items corresponding to the clicked letter
          else {
            items.each(function() {
              var item = $(this);
              var first_letter = paging.getFirstLetterOfItem(item);

              //== specify it's a special char if not an alpha char
              if (!isSimpleChar(first_letter)) {
                first_letter = "123";
              }

              if (first_letter != selected_letter) {
                item.addClass("hidden");
              }
              else {
                item.removeClass("hidden");
              }
            });
          }
        }

        //== close mobile filter
        desactivate_filterbar();
      });



      //====== on Sort By click
      desktop_sort_by_items.on("click.paging", function(e) {
        //== prevent default link behavior
        e.preventDefault();

        //== get sort type from item
        var sort_type = $(this).attr("class");

        //== sort items
        paging.sortItems(sort_type, $(lists[0]));
        paging.sortItems(sort_type, $(lists[1]));

        //-- reboot
        paging.reboot();

        //== close sort list
        paging.closeSort();
      });


    },
    /**
     * sortItems - sort list's items based on the sort type selected
     */
    sortItems: function(sort_type, list) {
      //-- alphabetical sort
      if (sort_type === "alpha-search") {
        paging.getItems(list, true).sort(function(a,b) {return ($(b).find("[data-search-name]").text()) < ($(a).find("[data-search-name]").text()) ? 1 : -1;}).appendTo(list);
      }

      //-- rebate sort
      if (sort_type === "rebate-search") {
        paging.getItems(list, true).sort(function(a,b) {return ($(b).find("[data-search-rebate]").text()) > ($(a).find("[data-search-rebate]").text()) ? 1 : -1;}).appendTo(list);
      }

      //-- expiration / date search
      if (sort_type === "age-search") {
        paging.getItems(list, true).sort(function(a,b) {return ($(b).find("[data-search-expire]").text()) > ($(a).find("[data-search-expire]").text()) ? 1 : -1;}).appendTo(list);
      }
    },
    /**
     * closeSort - close sort dropdown
     */
    closeSort: function() {
      var filter = paging.els.filter_module;
      filter.find(".sort-by-list .trigger").removeClass("open");
    },
  };





  /************************************************



        INITIATE PAGING



  *************************************************/
  if (desk_modules_using_paging.length || mob_modules_using_paging.length) {
    paging.setup(NB_PER_PAGE);
  }




  /************************************************



         ALPHA FILTER EVENT MANAGEMENT



  *************************************************/

  //=== ON ALPHA FILTER SWITCH CLICK
  $(document.body).on("click", desk_alpha_filter_switchs, function () {

    //== switch
    var _this = $(this);


    if (!_this.hasClass('selected')) {
      //== toggle selected class only if clicked button is not the active one
      $(desk_alpha_filter_switchs).toggleClass('selected');

      //== if LINE switch is clicked
      if (_this.hasClass("display_line")) {
        desk_item_list.find(".blocks").hide();
        desk_item_list.find(".lines").show();
      }
      //== if BLOCK switch is clicked
      else if (_this.hasClass("display_block")) {
        desk_item_list.find(".lines").hide();
        desk_item_list.find(".blocks").show();
      }
    }

  });


  $(document.body).on("click", desk_alpha_filter_select, function() {
    $(this).toggleClass("open");
  });


  $(document.body).on("click", ".see_all_link", function() {

    //== default
    var _this = $(this);

    //== get module where see_all_link has been clicked
    var alpha_filter = _this.parents("[data-type=module]");

    //== get the linked module class to switch view
    var module_class = alpha_filter.attr("data-link");

    //== get module object
    var module = $("."+module_class);

    //== if module exist, process switching
    if (module.length) {
      if (_this.is("[data-switched]")) {
        paging.setup(NB_PER_PAGE);
        _this.removeAttr("data-switched");
      }
      else {
        paging.stop();
        _this.attr("data-switched", "1");
      }
    }
    else {
      console.error("error while processing request");
    }
  });




  /**
   * gatherItemsFirstLetterAsObj - create an array of object containing first letter of an item
   * @param  {[type]} items [description]
   * @return {[type]}       [description]
   */
  function gatherItemsFirstLetterAsObj(items) {

    //== init
    var items_first_letter = [];

    //=== get item first letter and store it
    items.each(function() {
      var item = $(this);
      var name_els = item.find("[class*=name]");
      var nb_name_els = name_els.length;

      if (nb_name_els) {
        //== get the first one
        name_el = name_els.eq(0);

        // create a "first_letter" object
        var first_letter = {letter: name_el.text().charAt(0), item: item };
        items_first_letter.push(first_letter);
      }
    });

    return items_first_letter;
  }


  /**
   * getListOfItems - get the different lists of items for the linked module of a filter module
   * @param  {OBJECT} filter_module
   * @return {OBJECT ARRAY}
   */
  function getListOfItems(filter_module) {

    //== get linked module class name
    var module_class = filter_module.attr("data-link");
    //== create an object with it
    var module = $("."+module_class);

    //== if it exists...
    if (module.length) {

      //== if the module as the correct attr...
      if (module.is("[data-paging]")) {

        //== get the list class name of the module (to get the items inside)
        var list_name = module.attr("data-paging");
        var lists = module.find("."+list_name);

        //== if the lists exists...
        if (lists.length) {
          return lists;
        }
      }
    }
  }

  /**
   * setItemCount - display the number of items inside the dedicated area
   * @param  {OBJECT} filter_module
   * @param  {OBJECT ARRAY} items
   * @return VOID
   */
  function setItemCount(filter_module, items) {
    var item_count_el = filter_module.find(".nb_item_count");
    item_count_el.text(items.length+" "+item_count_el.text());
  }

  /**
   * isSimpleChar - test if given char is in a-z range
   * @param  {string}  char_string
   * @return {boolean}
   */
  function isSimpleChar(char_string) {
    //== init, lowercase
    char_string = char_string.toLowerCase();

    //regex rule
    var alpha_test = new RegExp("[a-z]");

    return alpha_test.test(char_string);
  }
